import { createSelector } from 'reselect';
import InterchangeProcessingDetailsColumns
  from '../../containers/InterchangeProcessingDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .INTERCHANGE_PROCESSING_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .INTERCHANGE_PROCESSING_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .INTERCHANGE_PROCESSING_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, InterchangeProcessingDetailsColumns);
